
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";

const TOKENS = {
    panel: "rgba(255,255,255,0.9)",
    radius: 8,
    dotIdle: "#CFCFCF",
    dotActive: "#E5007E",
    border: "#E9E9E9",
};

export default function DotStrip({
                                      count = 2,
                                      cur = 0,
                                      maxDots = 6,
                                      sx
                                  }) {
    const dots = Array.from({ length: Math.min(count, maxDots) });

    return (
        <Box
            sx={{
                width: { xs: 20, md: 25 },
                height: { xs: 66, md: 70 },
                bgcolor: '#fff',
                borderRadius: TOKENS.radius,
                border: `1px solid ${TOKENS.border}`,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                ...sx,
            }}
        >
            <Stack spacing={1.25} alignItems="center">
                {dots.map((_, i) => {
                    const isActive = i === cur;
                    return (
                        <Box
                            key={i}
                            role="button"
                            aria-label={`Εικόνα ${i + 1}`}
                            tabIndex={0}
                            sx={{
                                width: { xs: 5, md: 6 },
                                height: { xs: 5, md: 6 },
                                borderRadius: "50%",
                                bgcolor: isActive ? TOKENS.dotActive : TOKENS.dotIdle,
                            }}
                        />
                    );
                })}
            </Stack>
        </Box>
    );
}
